import { render, staticRenderFns } from "./gtr-badge-search-and-print.vue?vue&type=template&id=e8f99454&scoped=true"
import script from "./gtr-badge-search-and-print.vue?vue&type=script&lang=ts"
export * from "./gtr-badge-search-and-print.vue?vue&type=script&lang=ts"
import style0 from "./gtr-badge-search-and-print.vue?vue&type=style&index=0&id=e8f99454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f99454",
  null
  
)

export default component.exports